import { LitElement, html, css, styleMap } from '@hh/global.js'

class HHVideoWrapper extends LitElement {
  static properties = {
    isPlaying: {
      type: Boolean,
      state: true,
      reflect: true,
    },
    hoverButtonStyles: {
      type: Object,
      state: true
    }
  }

  constructor() {
    super()
    this.videoEl = this.querySelector('video')

    this.isPlaying = !this.videoEl.paused
    this.isPlaying = false

    this.hoverButtonStyles = {
      '--x': '50%',
      '--y': '50%'
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleMouseHover()
  }

  handleMouseHover() {
    this.addEventListener('mousemove', (e) => {
      const { width = 1, height = 1 } = e.currentTarget.getBoundingClientRect()
      const x = e.pageX - e.currentTarget.offsetLeft
      const y = e.pageY - e.currentTarget.offsetTop

      this.requestFrame = requestAnimationFrame(() => {
        this.hoverButtonStyles = {
          '--x': `${(x / width) * 100}%`,
          '--y': `${(y / height) * 100}%`
        }
      })
    })

    this.addEventListener('mouseleave', () => {
      cancelAnimationFrame(this.requestFrame)
      this.hoverButtonStyles = {
        '--x': '50%',
        '--y': '50%'
      }
    })
  }

  onClick(e) {
    const isPaused = this.videoEl.paused
    isPaused ? this.videoEl.play() : this.videoEl.pause()
    this.isPlaying = isPaused
  }

  playVideo() {
    this.videoEl.play()
    this.isPlaying = !this.videoEl.paused
  }

  static styles = css`
    :host .hh-video-wrapper {
      position: relative;
    }

    .hh-video-wrapper__overlay {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, var(--overlay-transparency));
    }

    .hh-video-wrapper__controls-container {
      position: absolute;
      display: block;
      bottom: 19px;
      right: 19px;
      z-index: 5;
    }

    .hh-video-wrapper__play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 100px;
      width: 100px;
      border-radius: 100px;
      border: none;
      background-color: var(--theme-color-reverse);
      font-weight: 500;
      transform: translate(-50%, -50%);
      cursor: pointer;
      z-index: 10;
    }

    @media screen and (min-width: 768px) {
      .hh-video-wrapper__play-btn {
        top: clamp(62px, var(--y, 50%), calc(100% - 62px));
        left: clamp(62px, var(--x, 50%), calc(100% - 62px));
        transition: top 25ms ease, left 25ms ease;
      }
    }

    .hh-video-wrapper__controls-btn {
      padding: 0;
      border: none;
      background: none;
      color: var(--theme-color-reverse);
      cursor: pointer;
    }

    .hh-video-wrapper__controls-btn[data-state='playing'] .hh-video-wrapper__play-icon,
    .hh-video-wrapper__controls-btn[data-state='paused'] .hh-video-wrapper__pause-icon {
      display: none;
    }
  `

  getPlayCirclButton() {
    if (!this.isPlaying) {
      return html`<button
        type="button"
        class="hh-video-wrapper__play-btn"
        @click="${this.playVideo}"
        style=${styleMap(this.hoverButtonStyles)}
      >
        Play video
      </button>`
    }

    return ``
  }

  render() {
    return html`
      <div class="hh-video-wrapper">
        ${this.getPlayCirclButton()}
        <slot></slot>
        <div class="hh-video-wrapper__controls-container">
          <button
            type="button"
            class="hh-video-wrapper__controls-btn"
            aria-label="Toggle video"
            @click="${this.onClick}"
            data-state="${this.isPlaying ? 'playing' : 'paused'}"
          >
            <div class="hh-video-wrapper__pause-icon" aria-hidden="true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="3" y="2" width="6" height="20" rx="1" stroke="currentColor" stroke-width="1.5"/>
                <rect x="15" y="2" width="6" height="20" rx="1" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
            <div class="hh-video-wrapper__play-icon" aria-hidden="true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.55 12.7 6.17 20.13c-.92.5-2.04-.15-2.04-1.2V4.07a1.38 1.38 0 0 1 2.04-1.2l13.38 7.43c.94.52.94 1.88 0 2.4Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    `
  }
}

customElements.define('hh-video-wrapper', HHVideoWrapper)
